import Toastify from 'toastify-js';
import 'toastify-js/src/toastify.css';
import axios from 'axios';
import { find, findAll } from '../utils/dom';



const formSejaNucleon = () => {

	const page = find(`[js-page='seja-nucleon']`);
	if(!page) return;


	// Função para exibir Toast
	const showToastify = (message) => {
		Toastify({
			text: message,
			duration: 4000,
			gravity: "top",
			position: "center",
			close: true,
			style: {
				background: "#AEFF00", 
				color: "black",
				borderRadius: "999px",
				padding: "12px 24px",
				fontFamily: "inherit",
				boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
			},
			className: "toastify-custom",
		}).showToast();
	};

	function fileToBase64(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = () => {
				// Remove o prefixo "data:application/pdf;base64,"
				const base64String = reader.result.split(',')[1];
				resolve(base64String);
			};
			reader.onerror = reject;
			reader.readAsDataURL(file);
		});
	}


	/*
	Função no atual momento não necessária.
	Se for necessária, voltar aqui.

	const enableVisibleFields = () => {
		steps.forEach((step) => {
			const inputs = step.querySelectorAll('input, textarea, select');
			inputs.forEach(input => {
				input.disabled = step.classList.contains('hidden');
			});
		});
	};

	-----------------------------------------------------------

	*/

	const $formValidation = {
		validarInputArquivo: (file, tipo_arquivo) =>{
			return file.type.includes(tipo_arquivo)
		}
	}

	const $forms = {
		formDesktop: find('[js-form="desktop"]') ?? undefined,
		formMobile: find('[js-form="mobile"]') ?? undefined,
	}

	const $Step = {
		
		stepDesktop:[
			{'passo': find(`[js-form="desktop"] [js-step="1"]`) ?? undefined},
			{'passo': find(`[js-form="desktop"] [js-step="2"]`) ?? undefined},
			{'passo': find(`[js-form="desktop"] [js-step="3"]`) ?? undefined},
		],
		buttonStepDesktop:[
			{'buttonPasso': find(`[js-button-form="desktop"][js-button-step="1"]`) ?? undefined},
			{'buttonPasso': find(`[js-button-form="desktop"][js-button-step="2"]`) ?? undefined},
			{'buttonPasso': find(`[js-button-form="desktop"][js-button-step="3"]`) ?? undefined},
		],
		buttonNextStepDesktop: findAll(`[js-form="desktop"] [js-button-next-step]`) ?? undefined,
		stepMobile:[
			{'passo': find(`[js-form="mobile"] [js-step="1"]`) ?? undefined},
			{'passo': find(`[js-form="mobile"] [js-step="2"]`) ?? undefined},
			{'passo': find(`[js-form="mobile"] [js-step="3"]`) ?? undefined},
		],
		buttonStepMobile:[
			{'buttonPasso': find(`[js-button-form="mobile"][js-button-step="1"]`) ?? undefined},
			{'buttonPasso': find(`[js-button-form="mobile"][js-button-step="2"]`) ?? undefined},
			{'buttonPasso': find(`[js-button-form="mobile"][js-button-step="3"]`) ?? undefined},
		],
		buttonNextStepMobile: findAll(`[js-form="mobile"] [js-button-next-step]`) ?? undefined,
		resetButtonStep: (_buttonSteps)=>{
			_buttonSteps.forEach((buttonStep)=>{
				buttonStep['buttonPasso'].classList.remove("number-step-active");
				buttonStep['buttonPasso'].classList.add("number-step-disable");
			})
		},
		activeButtonStep: (_stepNumber, _form) =>{
			const propriedadeAuxiliar =  (_form.getAttribute('js-form') == 'desktop') ?`[js-button-form="desktop"]`:`[js-button-form="mobile"]`
			
			find(`${propriedadeAuxiliar}[js-button-step="${_stepNumber}"]`)?.classList.remove('number-step-disable')
			find(`${propriedadeAuxiliar}[js-button-step="${_stepNumber}"]`)?.classList.add('number-step-active')
		},
		/**
		 * Função: updateProgress
		 * Descrição: Atualiza o progresso dos passos.
		 * 
		 */
		updateProgress: (_stepNumber, _typeButtonSteps, _form)=>{
			$Step.resetButtonStep(_typeButtonSteps)
			$Step.activeButtonStep(_stepNumber, _form)

			const propriedadeAuxiliar =  (_form.getAttribute('js-form') == 'desktop') ?`[js-bar-form="desktop"]`:`[js-bar-form="mobile"]`
			findAll(`${propriedadeAuxiliar} .line-green-contact`).forEach((line, index)=>{
				line.style.width = parseInt(_stepNumber) > index + 1 ? '100%' : '0';
			})
		},
		/**
		 * Função: resetSteps
		 * Descrição: Reseta todas as telas de cada passo deixando-as todas em hidden.
		 * Entrada: _steps é um objeto contendo todos as etapas de um form específico.
		 * @param {*} _steps 
		 */
		resetSteps: (_steps) =>{
			_steps.forEach((step)=>{
				step['passo'].classList.add("hidden");
				step['passo'].classList.remove('step-ativo');
			})
		},
		/**
		 * Função: addStep
		 * Descrição: Função que remove a classe hidden de um passo de tela específico.
		 * Entrada: Tela com o passo específico. 
		 * @param {*} _step 
		 */
		addStep: (_step, _form) =>{
			_form.querySelector(`[js-step="${_step}"]`)?.classList.remove('hidden')
			_form.querySelector(`[js-step="${_step}"]`)?.classList.add('step-ativo')
		},
		goToStep: (_stepNumber, _typeSteps, _typeButtonSteps, _form) =>{
			$Step.resetSteps(_typeSteps)
			$Step.addStep(_stepNumber, _form)
			$Step.updateProgress(_stepNumber, _typeButtonSteps, _form)
		},
		checkIndexAtualStep: (_form) =>{
			return _form.querySelector('[js-step].step-ativo')?.getAttribute('js-step') ?? 0;
		},

		validaStep:(_step, _form) =>{
			const requiredFields = _form.querySelectorAll(`[js-step="${parseInt(_step - 1)}"] [required]`);
			let valid = true;

			
			requiredFields.forEach((field) => {
				if(field.type === 'file'){
					valid = $formValidation.validarInputArquivo(field.files[0], 'application/pdf')
						
				}

				const isCheckbox = field.type === 'checkbox';
				const checked = isCheckbox ? _form.querySelector(`[js-step="${parseInt(_step - 1)}"] input[name="${field.name}"]:checked`) : true;
				const hasValue = isCheckbox ? checked : field.value.trim() !== '';
	
				field.classList.toggle('ring-2', !hasValue);
				field.classList.toggle('ring-[#FF3456]', !hasValue);
	
				if (!hasValue) valid = false;
			});

			
			return valid

		}
	}


	const $Badge = {
		badgeDesktop: find(`[js-badge="desktop"]`) ?? undefined,
		badgeMobile: find(`[js-badge="mobile"]`) ?? undefined,
		updateBadge: (_dropdown, _typeBadge) =>{
			const selectedCount = _dropdown.querySelectorAll('input[name="certificados_nomes"]:checked').length;
			_typeBadge.classList.toggle('hidden', selectedCount === 0);
			_typeBadge.textContent = selectedCount > 0 ? selectedCount : '';		
		} 
	}

	const $Dropdown = {
		dropdownDesktop: find(`[js-dropdown="desktop"]`),
		btnDropdownDesktop: find(`[js-button-dropdown="desktop"]`),
		dropdownMobile: find(`[js-dropdown="mobile"]`),
		btnDropdownMobile: find(`[js-button-dropdown="mobile"]`),
		toggleDropdown: (_dropdown, _force) =>{
			_dropdown?.classList.toggle('hidden', _force);
		}

	}

	const $contarCaracter = {
		init: (_textarea)=>{
			const textarea = _textarea;
			const charCount = document.createElement('p');
			charCount.className = 'text-neutral-60 text-pilat-caps-6 w-full text-right text-[10px]';
			textarea?.insertAdjacentElement('afterend', charCount);
			if (textarea) charCount.textContent = '0/500 caracteres';

			return charCount;
		},
		update: (_textarea, _charCount)=>{
			
			const length = _textarea.value.length;
			_charCount.textContent = `${length}/500 caracteres`;
			if (length > 500) {
				_textarea.value = _textarea.value.slice(0, 500);
				_charCount.textContent = `500/500 caracteres`;
			}
		}
	}

	


	/** Configurações Desktop */
	$forms.formDesktop?.addEventListener("submit", async (e)=>{
		e.preventDefault();

		
		const politicaCheckbox = e.target.querySelector(`input[name="politica"]`);
		const politicaValid = politicaCheckbox?.checked;
		politicaCheckbox?.classList.toggle('ring-2', !politicaValid);
		politicaCheckbox?.classList.toggle('ring-[#FF3456]', !politicaValid);
		if (!politicaValid){
			return;
		}


		const btnSubmit = e.target.querySelector("button[type=submit]");
    btnSubmit.disabled = true;



		//const base64 = await fileToBase64(e.target.querySelector("[js-inputCV]").files[0]);

		//const csrfToken = e.target.querySelector("[name='csrfmiddlewaretoken']").value

		const dadosForm = new FormData();

		dadosForm.append("nome", e.target.querySelector("[name='nome']").value);
		dadosForm.append("email", e.target.querySelector("[name='email']").value);
		dadosForm.append("telefone", e.target.querySelector("[name='telefone']").value);
		dadosForm.append("linkedin", e.target.querySelector("[name='linkedin']").value);
		dadosForm.append("apresentacao", e.target.querySelector("[name='mensagem']").value);
		const arrayCertificacao = Array.from(e.target.querySelectorAll("[name='certificados_nomes']:checked")).map(el => el.value);
		arrayCertificacao.forEach((item)=>{
			dadosForm.append("certificacao", item);
		})
		dadosForm.append("curriculo", e.target.querySelector("[js-inputCV]").files[0])


		const url = "/seja_nucleon/"
		axios.post(url, dadosForm,{
			headers: {
				'Content-Type': 'multipart/form-data',
			}
		})
		.then((response) => {
			showToastify(response.data?.message);
			e.target.reset()

			$Step.goToStep(1,$Step.stepDesktop, $Step.buttonStepDesktop, $forms.formDesktop)
			$Badge.updateBadge($Dropdown.dropdownDesktop, $Badge.badgeDesktop);
			//enableVisibleFields();

			const filenameSpan = e.target.querySelector('#cv-filename');
			if (filenameSpan) filenameSpan.textContent = '';
				btnSubmit.disabled = false;
			})
			.catch((response) =>{
				showToastify(response.data?.message)
				btnSubmit.disabled = false;
		});

	})

	const textAreaDesktop = $forms.formDesktop?.querySelector("[js-mensagem]");
	const inputCVDesktop = $forms.formDesktop?.querySelector("[js-inputCV]");

	const charCountDesktop = $contarCaracter.init(textAreaDesktop);
	textAreaDesktop?.addEventListener('input', (e)=>{
		$contarCaracter.update(e.target, charCountDesktop);
	})

	inputCVDesktop?.addEventListener('change', (e)=>{
		const file = e.target.files[0];

		if(file.type == 'application/pdf'){
			const filenamePara = $forms.formDesktop.querySelector("[js-cv-filename]");

			if (filenamePara) filenamePara.textContent = file ? file.name : '';
		}else{
			showToastify("Formato de arquivo inválido.");
		}
	})


	$Step.buttonStepDesktop?.forEach((button)=>{
		button['buttonPasso'].addEventListener("click",(e)=>{
			const indexStep = parseInt(e.target.getAttribute('js-button-step'));
			if($Step.checkIndexAtualStep($forms.formDesktop) > indexStep){
				$Step.goToStep(indexStep,$Step.stepDesktop,$Step.buttonStepDesktop,$forms.formDesktop);
			}
		})
	})

	$Step.buttonNextStepDesktop?.forEach((button)=>{
		button.addEventListener('click', (e)=>{
			const indexStepNext = e.target.getAttribute('js-button-next-step');
			if($Step.validaStep(indexStepNext, $forms.formDesktop)){
				$Step.goToStep(indexStepNext,$Step.stepDesktop,$Step.buttonStepDesktop,$forms.formDesktop);
			}
		})
	})

	
	$Dropdown.btnDropdownDesktop?.addEventListener("click", (e)=>{
		e.stopPropagation();
		$Dropdown.toggleDropdown($Dropdown.dropdownDesktop);
	})
	$Dropdown.dropdownDesktop?.addEventListener('change', (e)=>{
		if (e.target instanceof HTMLInputElement && e.target.name === 'certificados_nomes') {
			$Badge.updateBadge($Dropdown.dropdownDesktop, $Badge.badgeDesktop);
		}
	})

	/** Configurações Mobile */
	
	$forms.formMobile?.addEventListener("submit", async (e)=>{
		e.preventDefault();

		
		const politicaCheckbox = e.target.querySelector(`input[name="politica"]`);
		const politicaValid = politicaCheckbox?.checked;
		politicaCheckbox?.classList.toggle('ring-2', !politicaValid);
		politicaCheckbox?.classList.toggle('ring-[#FF3456]', !politicaValid);
		if (!politicaValid){
			return;
		}


		const btnSubmit = e.target.querySelector("button[type=submit]");
    btnSubmit.disabled = true;

  

		//const base64 = await fileToBase64(e.target.querySelector("[js-inputCV]").files[0]);
		const dadosForm = new FormData();

		dadosForm.append("nome", e.target.querySelector("[name='nome']").value);
		dadosForm.append("email", e.target.querySelector("[name='email']").value);
		dadosForm.append("telefone", e.target.querySelector("[name='telefone']").value);
		dadosForm.append("linkedin", e.target.querySelector("[name='linkedin']").value);
		dadosForm.append("apresentacao", e.target.querySelector("[name='mensagem']").value);
		dadosForm.append("certificacao", Array.from(e.target.querySelectorAll("[name='certificados_nomes']:checked")).map(el => el.value));
		dadosForm.append("curriculo", e.target.querySelector("[js-inputCV]").files[0])


		const url = "/seja_nucleon/"
		axios.post(url, dadosForm,{
			headers: {
				'Content-Type': 'multipart/form-data',
			}
		})
		.then((response) => {
			showToastify(response.data?.message);
			e.target.reset()

			$Step.goToStep(1,$Step.stepMobile, $Step.buttonStepMobile, $forms.formMobile)
			$Badge.updateBadge($Dropdown.dropdownMobile, $Badge.badgeMobile);
			//enableVisibleFields();

			const filenameSpan = e.target.querySelector('#cv-filename');
			if (filenameSpan) filenameSpan.textContent = '';
				btnSubmit.disabled = false;
			})
			.catch((response) =>{
				showToastify(response.data?.message)
				btnSubmit.disabled = false;
		});

	})

	const textAreaMobile = $forms.formMobile?.querySelector("[js-mensagem]");
	const inputCVMobile = $forms.formMobile?.querySelector("[js-inputCV]");

	const charCountMobile = $contarCaracter.init(textAreaMobile);
	textAreaMobile?.addEventListener('input', (e)=>{
		$contarCaracter.update(e.target, charCountMobile);
	})

	inputCVMobile?.addEventListener('change', (e)=>{
		const file = e.target.files[0];
		
		if(file.type == 'application/pdf'){
			const filenamePara = $forms.formDesktop.querySelector("[js-cv-filename]");
			if (filenamePara) filenamePara.textContent = file ? file.name : '';
		}else{
			showToastify("Formato de arquivo inválido.");
		}
	})


	$Step.buttonStepMobile?.forEach((button)=>{
		button['buttonPasso'].addEventListener("click",(e)=>{
			const indexStep = parseInt(e.target.getAttribute('js-button-step'));
			if($Step.checkIndexAtualStep($forms.formMobile) > indexStep){
				$Step.goToStep(indexStep,$Step.stepMobile,$Step.buttonStepMobile,$forms.formMobile);
			}
		})
	})

	$Step.buttonNextStepMobile?.forEach((button)=>{
		button.addEventListener('click', (e)=>{
			const indexStepNext = e.target.getAttribute('js-button-next-step');
			if($Step.validaStep(indexStepNext, $forms.formMobile)){
				$Step.goToStep(indexStepNext,$Step.stepMobile,$Step.buttonStepMobile,$forms.formMobile);
			}
		})
	})

	
	$Dropdown.btnDropdownMobile?.addEventListener("click", (e)=>{
		e.stopPropagation();
		$Dropdown.toggleDropdown($Dropdown.dropdownMobile);
	})
	$Dropdown.dropdownMobile?.addEventListener('change', (e)=>{
		if (e.target instanceof HTMLInputElement && e.target.name === 'certificados_nomes') {
			$Badge.updateBadge($Dropdown.dropdownMobile, $Badge.badgeMobile);
		}
	})


	


	

	



/*
	forms?.forEach((form)=>{
		form.addEventListener("submit", (e)=>{
				e.preventDefault();

        disableHiddenFields();

        if (!validateStep(step3)) return;

        const btnSubmit = e.target.querySelector("button[type=submit]");
        btnSubmit.disabled = true;

				const dados = {
					nome: e.target.querySelector("[name='nome']").value,
					email: e.target.querySelector("[name='email']").value,
					telefone: e.target.querySelector("[name='telefone']").value,
					linkedin: e.target.querySelector("[name='linkedin']").value,
					mensagem: e.target.querySelector("[name='mensagem']").value,
					certificacao: Array.from(e.target.querySelectorAll("[name='certificados_nomes']:checked")).map(el => el.value),
					curriculo: e.target.querySelector("[name='curriculo']").files[0],
				}
				
					const url = "/seja_nucleon/"
					axios.post(url, dados)
						.then((response) => {
							showToastify(response.data?.message);
							e.target.reset()

							goToStep(1);
							updateBadge();
							enableVisibleFields();

							const filenameSpan = form.querySelector('#cv-filename');
							if (filenameSpan) filenameSpan.textContent = '';

							btnSubmit.disabled = false;
						})
						.catch((response) =>{
							showToastify(response.data?.message)
							btnSubmit.disabled = false;
						});
		})
	})
	*/





/*


	
  document.addEventListener("DOMContentLoaded", () => {
    const sections = document.querySelectorAll('#banner-contato-seja-nucleon, #banner-contato-seja-nucleon-mobile');

    sections.forEach(section => {
      const form = section.querySelector('#seja-um-nucleon-contact');
      if (!form) return;

      const step1 = section.querySelector('#step-1');
      const step2 = section.querySelector('#step-2');
      const step3 = section.querySelector('#step-3');

      const btnNextSteps = section.querySelectorAll('#next-step');
      const telefoneInput = form.querySelector('#telefone');
      const lineGreen = section.querySelectorAll('.line-green-contact');
      const stepIndicators = section.querySelectorAll('.number-step-disable, .number-step-active');

      const btnDropdown = section.querySelector('#btn-certificacoes');
      const dropdown = section.querySelector('#dropdown');

      const badge = section.querySelector('#badge-certificacoes');
      const inputCV = section.querySelector('#curriculo');
      const steps = [step1, step2, step3];

      telefoneInput?.addEventListener('input', (e) => {
        const input = e.target;
        if (!(input instanceof HTMLInputElement)) return;
        let value = input.value.replace(/\D/g, '');
        if (value.length > 11) value = value.slice(0, 11);
        input.value = value.length <= 10
          ? value.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3')
          : value.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
      });

      const toggleDropdown = (force) => {
        dropdown?.classList.toggle('hidden', force);
      };

      btnDropdown?.addEventListener('click', (e) => {
        e.stopPropagation();
        toggleDropdown();
      });

      document.addEventListener('click', (e) => {
        if (!dropdown?.contains(e.target) && !btnDropdown?.contains(e.target)) {
          toggleDropdown(true);
        }
      });

      const updateBadge = () => {
        const selectedCount = dropdown.querySelectorAll('input[name="certificados_nomes"]:checked').length;
        badge.classList.toggle('hidden', selectedCount === 0);
        badge.textContent = selectedCount > 0 ? selectedCount : '';				
      };

      dropdown?.addEventListener('change', (e) => {
        if (e.target instanceof HTMLInputElement && e.target.name === 'certificados_nomes') {
          updateBadge();
        }
      });

      btnNextSteps[0]?.addEventListener('click', () => {
        if (validateStep(step1)) goToStep(2);
      });

      btnNextSteps[1]?.addEventListener('click', () => {
        if (validateStep(step2)) goToStep(3);
      });

      stepIndicators.forEach((el, idx) => {
        el.addEventListener('click', () => {
          const targetStep = idx + 1;
          const currentStep = getCurrentStep();
          if (targetStep < currentStep) goToStep(targetStep);
        });
      });

      const goToStep = (stepNumber) => {
        steps.forEach((step, idx) => {
          step.classList.toggle('hidden', idx + 1 !== stepNumber);
        });
        enableVisibleFields();
        updateProgress(stepNumber);
      };

      const getCurrentStep = () => {
        return steps.findIndex(step => !step.classList.contains('hidden')) + 1;
      };

      const updateProgress = (stepNumber) => {
        stepIndicators.forEach((el, idx) => {
          el.classList.toggle('number-step-active', idx + 1 === stepNumber);
          el.classList.toggle('number-step-disable', idx + 1 !== stepNumber);
        });
        lineGreen.forEach((line, index) => {
          line.style.width = stepNumber > index + 1 ? '100%' : '0';
        });
      };

      const disableHiddenFields = () => {
        steps.forEach((step) => {
          const inputs = step.querySelectorAll('input, textarea, select');
          inputs.forEach(input => {
            input.disabled = step.classList.contains('hidden');
          });
        });
      };

      const enableVisibleFields = () => {
        steps.forEach((step) => {
          const inputs = step.querySelectorAll('input, textarea, select');
          inputs.forEach(input => {
            input.disabled = step.classList.contains('hidden');
          });
        });
      };

    function getCookie(name) {
        let cookieValue = null;
        if (document.cookie && document.cookie !== "") {
            let cookies = document.cookie.split(";");
            for (let i = 0; i < cookies.length; i++) {
                let cookie = cookies[i].trim();
                if (cookie.startsWith(name + "=")) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }
      form.addEventListener('submit', (e) => {
        e.preventDefault();
				console.log(e)

        disableHiddenFields();

        if (!validateStep(step3)) return;

        const btnSubmit = form.querySelector("button[type=submit]");
        btnSubmit.disabled = true;

				const dados = {
					nome: form.querySelector("[name='nome']").value,
					email: form.querySelector("[name='email']").value,
					telefone: form.querySelector("[name='telefone']").value,
					linkedin: form.querySelector("[name='linkedin']").value,
					mensagem: form.querySelector("[name='mensagem']").value,
					certificacao: Array.from(form.querySelectorAll("[name='certificados_nomes']:checked")).map(el => el.value),
					curriculo: inputCV.files[0],
				}
				
					const url = "/seja_nucleon/"
					axios.post(url, dados)
						.then((response) => {
							showToastify(response.data?.message);
							e.target.reset()

							goToStep(1);
							updateBadge();
							enableVisibleFields();

							const filenameSpan = form.querySelector('#cv-filename');
							if (filenameSpan) filenameSpan.textContent = '';

							btnSubmit.disabled = false;
						})
						.catch((response) =>{
							showToastify(response.data?.message)
							btnSubmit.disabled = false;
						});


      });

      const validateStep = (step) => {
        const requiredFields = step.querySelectorAll('[required]');
        let valid = true;

        requiredFields.forEach((field) => {
          const isCheckbox = field.type === 'checkbox';
          const checked = isCheckbox ? step.querySelector(`input[name="${field.name}"]:checked`) : true;
          const hasValue = isCheckbox ? checked : field.value.trim() !== '';

          field.classList.toggle('ring-2', !hasValue);
          field.classList.toggle('ring-[#FF3456]', !hasValue);

          if (!hasValue) valid = false;
        });

        if (step === step3) {
          const politicaCheckbox = step.querySelector('#politica');
          const politicaValid = politicaCheckbox?.checked;
          politicaCheckbox?.classList.toggle('ring-2', !politicaValid);
          politicaCheckbox?.classList.toggle('ring-[#FF3456]', !politicaValid);
          if (!politicaValid) valid = false;
        }

        return valid;
      };

      inputCV?.addEventListener('change', () => {
        const file = inputCV.files[0];
        const filenamePara = form.querySelector('#cv-filename');
        if (filenamePara) filenamePara.textContent = file ? file.name : '';
      });

      const textarea = form.querySelector('#mensagem');
      const charCount = document.createElement('p');
      charCount.className = 'text-neutral-60 text-pilat-caps-6 w-full text-right text-[10px]';
      textarea?.insertAdjacentElement('afterend', charCount);

      const updateCharCount = () => {
        const length = textarea.value.length;
        charCount.textContent = `${length}/500 caracteres`;
        if (length > 500) {
          textarea.value = textarea.value.slice(0, 500);
          charCount.textContent = `500/500 caracteres`;
        }
      };

      textarea?.addEventListener('input', updateCharCount);
      if (textarea) charCount.textContent = '0/500 caracteres';

      goToStep(1);
    });
  });*/




}

export default formSejaNucleon;
